export const favoriteFilterKeys = {
  affiliates: 'favWRAffiliates',
  trackers: 'favWRTrackers',
  webhooks: 'favWRWebhooks',
  webhook_types: 'favWRWebhookTypes',
  statuses: 'favWRStatuses',
}
